module.exports = __webpack_public_path__ + "static/media/DIAMOND.eab17256.png";